import * as React from "react"
import {Navigate} from "react-router-dom";
import {useSignal} from "@preact/signals-react";
import {Alert, AlertTitle, Box, Grid} from "@mui/material";
import {ButtonLoadingSeeker, IconSeeker, PasswordFieldSeeker, TextFieldSeeker} from "@ui-seeker/core";

import {useUserApp} from "@hooks";
import {isLogged} from "@signals";


export default function LoginFormBlock() {
	const email = useSignal('')
	const password = useSignal('')

	const { handleLogin, error, isLoadingLogin } = useUserApp()

	const handleSubmit = e => {
		e.preventDefault()
		handleLogin(email.value, password.value)
	}

	return <Box component="form" onSubmit={handleSubmit}>
		<Grid container spacing={2}>

			{ !!error && <Grid item xs={12}>
				<Alert severity="error">
					<AlertTitle>Login Error</AlertTitle>
					{error}
				</Alert>
			</Grid> }

			<Grid item xs={12}>
				<TextFieldSeeker
					label="Enter your email"
					value={email.value}
					onChange={e => email.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<PasswordFieldSeeker
					label="Enter your password"
					value={password.value}
					onChange={e => password.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<ButtonLoadingSeeker
					type="submit"
					loading={isLoadingLogin}
					startIcon={<IconSeeker icon="right-to-bracket" />}
					sx={{ width: 1 }}
				>
					Log in
				</ButtonLoadingSeeker>
			</Grid>
		</Grid>
	</Box>
}